<template>
  <OfficeLayout :style="{'margin-top': '-86px'}">
    <HelperProvider
        v-if="isHelperOpen"
        class="col-span-2"
        :helper-slug="`wizard-step-${current_step}`"/>
    <TheWizardNav :current_step="current_step"/>
    <transition name="router-anim">
      <component :is="`wizard-step-${current_step}`" @nextStep="current_step++"/>
    </transition>
  </OfficeLayout>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import OfficeLayout from "@/components/layouts/cabinet/OfficeLayout";
import TheWizardNav from "@/components/cabinet/Wizard/TheWizardNav/TheWizardNav";
import WizardStep1 from "@/components/cabinet/Wizard/Steps/WizardStep1";
import WizardStep2 from "@/components/cabinet/Wizard/Steps/WizardStep2";
import WizardStep3 from "@/components/cabinet/Wizard/Steps/WizardStep3";
import WizardStep4 from "@/components/cabinet/Wizard/Steps/WizardStep4";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import HelperProvider from "@/components/common/Helper/HelperProvider";

export default {
  name: "TheWizard",
  components: {
    HelperProvider,
    TopGradientBlockLayout,
    TheWizardNav,
    OfficeLayout,
    WizardStep1,
    WizardStep2,
    WizardStep3,
    WizardStep4
  },
  data() {
    return {
      current_step: null
    }
  },
  computed: {
    ...mapGetters('cabinet/helper', ['isHelperOpen'])
  },
  methods: {
    ...mapActions('cabinet/user', ['disableWizard'])
  },
  created() {
    this.current_step = 1;

  },
  watch: {
    current_step(val) {
      this.$store.commit('cabinet/helper/hideHelperBlock');
      this.$store.commit('cabinet/helper/displayHelperButton', val !== 4);
      if (val === 4) {
        this.disableWizard()
      }
    }
  },
  beforeDestroy() {
    if (this.current_step !== 4) {
      this.$store.commit('cabinet/helper/displayHelperButton', false);
    }
  }
}
</script>